import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGithub = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#1A1919",
			d: "M11.981 2C6.47 2 2 6.469 2 11.981c0 4.41 2.86 8.152 6.826 9.472.499.092.682-.217.682-.48 0-.238-.01-1.025-.014-1.859-2.776.604-3.362-1.177-3.362-1.177-.454-1.154-1.109-1.461-1.109-1.461-.905-.62.069-.607.069-.607 1.002.07 1.53 1.029 1.53 1.029.89 1.526 2.335 1.085 2.904.83.09-.645.349-1.086.634-1.335-2.217-.253-4.548-1.108-4.548-4.933 0-1.09.39-1.98 1.029-2.68-.104-.25-.445-1.266.097-2.64 0 0 .838-.269 2.745 1.022a9.567 9.567 0 0 1 2.498-.335 9.592 9.592 0 0 1 2.501.335c1.905-1.29 2.742-1.023 2.742-1.023.543 1.375.202 2.39.098 2.642.64.699 1.027 1.59 1.027 2.679 0 3.834-2.335 4.678-4.557 4.925.358.31.677.917.677 1.848 0 1.336-.012 2.41-.012 2.74 0 .265.18.576.686.478a9.983 9.983 0 0 0 6.82-9.47C21.963 6.47 17.493 2 11.98 2"
		})
	})
});
export default SvgGithub;
